<div class="container-fluid" >
  <div class="row top10">
    <div class="col-xs-12">
      <h3>Travelers</h3>
    </div>
  </div>

  <hr style="margin-top: 2px; margin-bottom: 2px" />

  <aims-common-table
    id="travelers-table"
    [dataSource]="travelers | async"
    [header]="header"
    [permissions]="permissions"
    (rowUpdated)="handleRowUpdate($event)"
    [stickyHeader]="true">

    <aims-common-table-dynamic-row id="status">
      <ng-template viewMode let-element >
        {{ element.status }}
      </ng-template>

      <ng-template editMode let-element let-dynamicControl="dynamicControl">
        <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
        <mat-select style="width: 150px" [formControl]="dynamicControl" required>
            <mat-option *ngFor="let ts of travelerStatuses| async" [value]="ts.statusCode">
                {{ ts.codePlusStatus }}
            </mat-option>
        </mat-select>
        </mat-form-field>
      </ng-template>
    </aims-common-table-dynamic-row>
    </aims-common-table>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
